{
  "schemaVersion": 1,
  "source": {
    "tool": "gitleaks",
    "ref": "v8.18.4",
    "generatedFrom": "vendor/gitleaks/gitleaks.toml"
  },
  "rules": [
    {
      "id": "adafruit-api-key",
      "description": "Identified a potential Adafruit API Key, which could lead to unauthorized access to Adafruit services and sensitive data exposure.",
      "regex": "(?:adafruit)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9_-]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "adafruit"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "adobe-client-id",
      "description": "Detected a pattern that resembles an Adobe OAuth Web Client ID, posing a risk of compromised Adobe integrations and data breaches.",
      "regex": "(?:adobe)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-f0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "adobe"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "adobe-client-secret",
      "description": "Discovered a potential Adobe Client Secret, which, if exposed, could allow unauthorized Adobe service access and data manipulation.",
      "regex": "\\b((p8e-)[a-z0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "p8e-"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "age-secret-key",
      "description": "Discovered a potential Age encryption tool secret key, risking data decryption and unauthorized access to sensitive information.",
      "regex": "AGE-SECRET-KEY-1[QPZRY9X8GF2TVDW0S3JN54KHCE6MUA7L]{58}",
      "keywords": [
        "age-secret-key-1"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "airtable-api-key",
      "description": "Uncovered a possible Airtable API Key, potentially compromising database access and leading to data leakage or alteration.",
      "regex": "(?:airtable)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{17})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "airtable"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "algolia-api-key",
      "description": "Identified an Algolia API Key, which could result in unauthorized search operations and data exposure on Algolia-managed platforms.",
      "regex": "(?:algolia)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "algolia"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "alibaba-access-key-id",
      "description": "Detected an Alibaba Cloud AccessKey ID, posing a risk of unauthorized cloud resource access and potential data compromise.",
      "regex": "\\b((LTAI)[a-z0-9]{20})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "ltai"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "alibaba-secret-key",
      "description": "Discovered a potential Alibaba Cloud Secret Key, potentially allowing unauthorized operations and data access within Alibaba Cloud.",
      "regex": "(?:alibaba)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{30})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "alibaba"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "asana-client-id",
      "description": "Discovered a potential Asana Client ID, risking unauthorized access to Asana projects and sensitive task information.",
      "regex": "(?:asana)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([0-9]{16})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "asana"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "asana-client-secret",
      "description": "Identified an Asana Client Secret, which could lead to compromised project management integrity and unauthorized access.",
      "regex": "(?:asana)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "asana"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "atlassian-api-token",
      "description": "Detected an Atlassian API token, posing a threat to project management and collaboration tool security and data confidentiality.",
      "regex": "(?:atlassian|confluence|jira)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{24})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "atlassian",
        "confluence",
        "jira"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "authress-service-client-access-key",
      "description": "Uncovered a possible Authress Service Client Access Key, which may compromise access control services and sensitive data.",
      "regex": "\\b((?:sc|ext|scauth|authress)_[a-z0-9]{5,30}\\.[a-z0-9]{4,6}\\.acc[_-][a-z0-9-]{10,32}\\.[a-z0-9+/_=-]{30,120})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "sc_",
        "ext_",
        "scauth_",
        "authress_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "aws-access-token",
      "description": "Identified a pattern that may indicate AWS credentials, risking unauthorized cloud resource access and data breaches on AWS platforms.",
      "regex": "(?:A3T[A-Z0-9]|AKIA|ASIA|ABIA|ACCA)[A-Z0-9]{16}",
      "keywords": [
        "akia",
        "asia",
        "abia",
        "acca"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "beamer-api-token",
      "description": "Detected a Beamer API token, potentially compromising content management and exposing sensitive notifications and updates.",
      "regex": "(?:beamer)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(b_[a-z0-9=_\\-]{44})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "beamer"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "bitbucket-client-id",
      "description": "Discovered a potential Bitbucket Client ID, risking unauthorized repository access and potential codebase exposure.",
      "regex": "(?:bitbucket)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "bitbucket"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "bitbucket-client-secret",
      "description": "Discovered a potential Bitbucket Client Secret, posing a risk of compromised code repositories and unauthorized access.",
      "regex": "(?:bitbucket)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9=_\\-]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "bitbucket"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "bittrex-access-key",
      "description": "Identified a Bittrex Access Key, which could lead to unauthorized access to cryptocurrency trading accounts and financial loss.",
      "regex": "(?:bittrex)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "bittrex"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "bittrex-secret-key",
      "description": "Detected a Bittrex Secret Key, potentially compromising cryptocurrency transactions and financial security.",
      "regex": "(?:bittrex)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "bittrex"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "clojars-api-token",
      "description": "Uncovered a possible Clojars API token, risking unauthorized access to Clojure libraries and potential code manipulation.",
      "regex": "(CLOJARS_)[a-z0-9]{60}",
      "flags": "i",
      "keywords": [
        "clojars"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "cloudflare-api-key",
      "description": "Detected a Cloudflare API Key, potentially compromising cloud application deployments and operational security.",
      "regex": "(?:cloudflare)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9_-]{40})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "cloudflare"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "cloudflare-global-api-key",
      "description": "Detected a Cloudflare Global API Key, potentially compromising cloud application deployments and operational security.",
      "regex": "(?:cloudflare)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-f0-9]{37})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "cloudflare"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "cloudflare-origin-ca-key",
      "description": "Detected a Cloudflare Origin CA Key, potentially compromising cloud application deployments and operational security.",
      "regex": "\\b(v1\\.0-[a-f0-9]{24}-[a-f0-9]{146})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "keywords": [
        "cloudflare",
        "v1.0-"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "codecov-access-token",
      "description": "Found a pattern resembling a Codecov Access Token, posing a risk of unauthorized access to code coverage reports and sensitive data.",
      "regex": "(?:codecov)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "codecov"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "coinbase-access-token",
      "description": "Detected a Coinbase Access Token, posing a risk of unauthorized access to cryptocurrency accounts and financial transactions.",
      "regex": "(?:coinbase)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9_-]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "coinbase"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "confluent-access-token",
      "description": "Identified a Confluent Access Token, which could compromise access to streaming data platforms and sensitive data flow.",
      "regex": "(?:confluent)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{16})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "confluent"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "confluent-secret-key",
      "description": "Found a Confluent Secret Key, potentially risking unauthorized operations and data access within Confluent services.",
      "regex": "(?:confluent)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "confluent"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "contentful-delivery-api-token",
      "description": "Discovered a Contentful delivery API token, posing a risk to content management systems and data integrity.",
      "regex": "(?:contentful)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9=_\\-]{43})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "contentful"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "databricks-api-token",
      "description": "Uncovered a Databricks API token, which may compromise big data analytics platforms and sensitive data processing.",
      "regex": "\\b(dapi[a-h0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "dapi"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "datadog-access-token",
      "description": "Detected a Datadog Access Token, potentially risking monitoring and analytics data exposure and manipulation.",
      "regex": "(?:datadog)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{40})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "datadog"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "defined-networking-api-token",
      "description": "Identified a Defined Networking API token, which could lead to unauthorized network operations and data breaches.",
      "regex": "(?:dnkey)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(dnkey-[a-z0-9=_\\-]{26}-[a-z0-9=_\\-]{52})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "dnkey"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "digitalocean-access-token",
      "description": "Found a DigitalOcean OAuth Access Token, risking unauthorized cloud resource access and data compromise.",
      "regex": "\\b(doo_v1_[a-f0-9]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "doo_v1_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "digitalocean-pat",
      "description": "Discovered a DigitalOcean Personal Access Token, posing a threat to cloud infrastructure security and data privacy.",
      "regex": "\\b(dop_v1_[a-f0-9]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "dop_v1_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "digitalocean-refresh-token",
      "description": "Uncovered a DigitalOcean OAuth Refresh Token, which could allow prolonged unauthorized access and resource manipulation.",
      "regex": "\\b(dor_v1_[a-f0-9]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "dor_v1_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "discord-api-token",
      "description": "Detected a Discord API key, potentially compromising communication channels and user data privacy on Discord.",
      "regex": "(?:discord)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-f0-9]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "discord"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "discord-client-id",
      "description": "Identified a Discord client ID, which may lead to unauthorized integrations and data exposure in Discord applications.",
      "regex": "(?:discord)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([0-9]{18})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "discord"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "discord-client-secret",
      "description": "Discovered a potential Discord client secret, risking compromised Discord bot integrations and data leaks.",
      "regex": "(?:discord)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9=_\\-]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "discord"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "doppler-api-token",
      "description": "Discovered a Doppler API token, posing a risk to environment and secrets management security.",
      "regex": "(dp\\.pt\\.)[a-z0-9]{43}",
      "flags": "i",
      "keywords": [
        "doppler"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "droneci-access-token",
      "description": "Detected a Droneci Access Token, potentially compromising continuous integration and deployment workflows.",
      "regex": "(?:droneci)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "droneci"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "dropbox-api-token",
      "description": "Identified a Dropbox API secret, which could lead to unauthorized file access and data breaches in Dropbox storage.",
      "regex": "(?:dropbox)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{15})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "dropbox"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "dropbox-long-lived-api-token",
      "description": "Found a Dropbox long-lived API token, risking prolonged unauthorized access to cloud storage and sensitive data.",
      "regex": "(?:dropbox)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{11}(AAAAAAAAAA)[a-z0-9\\-_=]{43})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "dropbox"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "dropbox-short-lived-api-token",
      "description": "Discovered a Dropbox short-lived API token, posing a risk of temporary but potentially harmful data access and manipulation.",
      "regex": "(?:dropbox)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(sl\\.[a-z0-9\\-=_]{135})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "dropbox"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "duffel-api-token",
      "description": "Uncovered a Duffel API token, which may compromise travel platform integrations and sensitive customer data.",
      "regex": "duffel_(test|live)_[a-z0-9_\\-=]{43}",
      "flags": "i",
      "keywords": [
        "duffel"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "dynatrace-api-token",
      "description": "Detected a Dynatrace API token, potentially risking application performance monitoring and data exposure.",
      "regex": "dt0c01\\.[a-z0-9]{24}\\.[a-z0-9]{64}",
      "flags": "i",
      "keywords": [
        "dynatrace"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "easypost-api-token",
      "description": "Identified an EasyPost API token, which could lead to unauthorized postal and shipment service access and data exposure.",
      "regex": "\\bEZAK[a-z0-9]{54}",
      "flags": "i",
      "keywords": [
        "ezak"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "easypost-test-api-token",
      "description": "Detected an EasyPost test API token, risking exposure of test environments and potentially sensitive shipment data.",
      "regex": "\\bEZTK[a-z0-9]{54}",
      "flags": "i",
      "keywords": [
        "eztk"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "etsy-access-token",
      "description": "Found an Etsy Access Token, potentially compromising Etsy shop management and customer data.",
      "regex": "(?:etsy)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{24})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "etsy"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "facebook-access-token",
      "description": "Discovered a Facebook Access Token, posing a risk of unauthorized access to Facebook accounts and personal data exposure.",
      "regex": "\\b(\\d{15,16}(\\||%)[0-9a-z\\-_]{27,40})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "facebook-page-access-token",
      "description": "Discovered a Facebook Page Access Token, posing a risk of unauthorized access to Facebook accounts and personal data exposure.",
      "regex": "\\b(EAA[MC][a-z0-9]{20,})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "eaam",
        "eaac"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "facebook-secret",
      "description": "Discovered a Facebook Application secret, posing a risk of unauthorized access to Facebook accounts and personal data exposure.",
      "regex": "(?:facebook)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-f0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "facebook"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "fastly-api-token",
      "description": "Uncovered a Fastly API key, which may compromise CDN and edge cloud services, leading to content delivery and security issues.",
      "regex": "(?:fastly)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9=_\\-]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "fastly"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "finicity-api-token",
      "description": "Detected a Finicity API token, potentially risking financial data access and unauthorized financial operations.",
      "regex": "(?:finicity)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-f0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "finicity"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "finicity-client-secret",
      "description": "Identified a Finicity Client Secret, which could lead to compromised financial service integrations and data breaches.",
      "regex": "(?:finicity)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{20})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "finicity"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "finnhub-access-token",
      "description": "Found a Finnhub Access Token, risking unauthorized access to financial market data and analytics.",
      "regex": "(?:finnhub)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{20})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "finnhub"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "flickr-access-token",
      "description": "Discovered a Flickr Access Token, posing a risk of unauthorized photo management and potential data leakage.",
      "regex": "(?:flickr)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "flickr"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "flutterwave-encryption-key",
      "description": "Uncovered a Flutterwave Encryption Key, which may compromise payment processing and sensitive financial information.",
      "regex": "FLWSECK_TEST-[a-h0-9]{12}",
      "flags": "i",
      "keywords": [
        "flwseck_test"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "flutterwave-public-key",
      "description": "Detected a Finicity Public Key, potentially exposing public cryptographic operations and integrations.",
      "regex": "FLWPUBK_TEST-[a-h0-9]{32}-X",
      "flags": "i",
      "keywords": [
        "flwpubk_test"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "flutterwave-secret-key",
      "description": "Identified a Flutterwave Secret Key, risking unauthorized financial transactions and data breaches.",
      "regex": "FLWSECK_TEST-[a-h0-9]{32}-X",
      "flags": "i",
      "keywords": [
        "flwseck_test"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "frameio-api-token",
      "description": "Found a Frame.io API token, potentially compromising video collaboration and project management.",
      "regex": "fio-u-[a-z0-9\\-_=]{64}",
      "flags": "i",
      "keywords": [
        "fio-u-"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "freshbooks-access-token",
      "description": "Discovered a Freshbooks Access Token, posing a risk to accounting software access and sensitive financial data exposure.",
      "regex": "(?:freshbooks)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "freshbooks"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "gcp-api-key",
      "description": "Uncovered a GCP API key, which could lead to unauthorized access to Google Cloud services and data breaches.",
      "regex": "\\b(AIza[0-9A-Za-z\\\\-_]{35})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "aiza"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "generic-api-key",
      "description": "Detected a Generic API Key, potentially exposing access to various services and sensitive operations.",
      "regex": "(?:key|api|token|secret|client|passwd|password|auth|access)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([0-9a-z\\-_.=]{10,150})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "key",
        "api",
        "token",
        "secret",
        "client",
        "passwd",
        "password",
        "auth",
        "access"
      ],
      "entropy": 3.5,
      "secretGroup": 1,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "github-app-token",
      "description": "Identified a GitHub App Token, which may compromise GitHub application integrations and source code security.",
      "regex": "(ghu|ghs)_[0-9a-zA-Z]{36}",
      "keywords": [
        "ghu_",
        "ghs_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "github-fine-grained-pat",
      "description": "Found a GitHub Fine-Grained Personal Access Token, risking unauthorized repository access and code manipulation.",
      "regex": "github_pat_[0-9a-zA-Z_]{82}",
      "keywords": [
        "github_pat_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "github-oauth",
      "description": "Discovered a GitHub OAuth Access Token, posing a risk of compromised GitHub account integrations and data leaks.",
      "regex": "gho_[0-9a-zA-Z]{36}",
      "keywords": [
        "gho_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "github-pat",
      "description": "Uncovered a GitHub Personal Access Token, potentially leading to unauthorized repository access and sensitive content exposure.",
      "regex": "ghp_[0-9a-zA-Z]{36}",
      "keywords": [
        "ghp_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "github-refresh-token",
      "description": "Detected a GitHub Refresh Token, which could allow prolonged unauthorized access to GitHub services.",
      "regex": "ghr_[0-9a-zA-Z]{36}",
      "keywords": [
        "ghr_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "gitlab-pat",
      "description": "Identified a GitLab Personal Access Token, risking unauthorized access to GitLab repositories and codebase exposure.",
      "regex": "glpat-[0-9a-zA-Z\\-\\_]{20}",
      "keywords": [
        "glpat-"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "gitlab-ptt",
      "description": "Found a GitLab Pipeline Trigger Token, potentially compromising continuous integration workflows and project security.",
      "regex": "glptt-[0-9a-f]{40}",
      "keywords": [
        "glptt-"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "gitlab-rrt",
      "description": "Discovered a GitLab Runner Registration Token, posing a risk to CI/CD pipeline integrity and unauthorized access.",
      "regex": "GR1348941[0-9a-zA-Z\\-\\_]{20}",
      "keywords": [
        "gr1348941"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "gitter-access-token",
      "description": "Uncovered a Gitter Access Token, which may lead to unauthorized access to chat and communication services.",
      "regex": "(?:gitter)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9_-]{40})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "gitter"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "gocardless-api-token",
      "description": "Detected a GoCardless API token, potentially risking unauthorized direct debit payment operations and financial data exposure.",
      "regex": "(?:gocardless)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(live_[a-z0-9\\-_=]{40})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "live_",
        "gocardless"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "grafana-api-key",
      "description": "Identified a Grafana API key, which could compromise monitoring dashboards and sensitive data analytics.",
      "regex": "\\b(eyJrIjoi[A-Za-z0-9]{70,400}={0,2})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "eyjrijoi"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "grafana-cloud-api-token",
      "description": "Found a Grafana cloud API token, risking unauthorized access to cloud-based monitoring services and data exposure.",
      "regex": "\\b(glc_[A-Za-z0-9+/]{32,400}={0,2})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "glc_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "grafana-service-account-token",
      "description": "Discovered a Grafana service account token, posing a risk of compromised monitoring services and data integrity.",
      "regex": "\\b(glsa_[A-Za-z0-9]{32}_[A-Fa-f0-9]{8})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "glsa_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "hashicorp-tf-api-token",
      "description": "Uncovered a HashiCorp Terraform user/org API token, which may lead to unauthorized infrastructure management and security breaches.",
      "regex": "[a-z0-9]{14}\\.atlasv1\\.[a-z0-9\\-_=]{60,70}",
      "flags": "i",
      "keywords": [
        "atlasv1"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "hashicorp-tf-password",
      "description": "Identified a HashiCorp Terraform password field, risking unauthorized infrastructure configuration and security breaches.",
      "regex": "(?:administrator_login_password|password)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(\"[a-z0-9=_\\-]{8,20}\")(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "administrator_login_password",
        "password"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "heroku-api-key",
      "description": "Detected a Heroku API Key, potentially compromising cloud application deployments and operational security.",
      "regex": "(?:heroku)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "heroku"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "hubspot-api-key",
      "description": "Found a HubSpot API Token, posing a risk to CRM data integrity and unauthorized marketing operations.",
      "regex": "(?:hubspot)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "hubspot"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "huggingface-access-token",
      "description": "Discovered a Hugging Face Access token, which could lead to unauthorized access to AI models and sensitive data.",
      "regex": "(?:^|[\\\\'\"` >=:])(hf_[a-zA-Z]{34})(?:$|[\\\\'\"` <])",
      "keywords": [
        "hf_"
      ],
      "entropy": 1,
      "secretGroup": 1,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "huggingface-organization-api-token",
      "description": "Uncovered a Hugging Face Organization API token, potentially compromising AI organization accounts and associated data.",
      "regex": "(?:^|[\\\\'\"` >=:\\(,)])(api_org_[a-zA-Z]{34})(?:$|[\\\\'\"` <\\),])",
      "keywords": [
        "api_org_"
      ],
      "entropy": 2,
      "secretGroup": 1,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "infracost-api-token",
      "description": "Detected an Infracost API Token, risking unauthorized access to cloud cost estimation tools and financial data.",
      "regex": "\\b(ico-[a-zA-Z0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "ico-"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "intercom-api-key",
      "description": "Identified an Intercom API Token, which could compromise customer communication channels and data privacy.",
      "regex": "(?:intercom)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9=_\\-]{60})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "intercom"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "intra42-client-secret",
      "description": "Found a Intra42 client secret, which could lead to unauthorized access to the 42School API and sensitive data.",
      "regex": "\\b(s-s4t2(?:ud|af)-[abcdef0123456789]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "intra",
        "s-s4t2ud-",
        "s-s4t2af-"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "jfrog-api-key",
      "description": "Found a JFrog API Key, posing a risk of unauthorized access to software artifact repositories and build pipelines.",
      "regex": "(?:jfrog|artifactory|bintray|xray)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{73})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "jfrog",
        "artifactory",
        "bintray",
        "xray"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "jfrog-identity-token",
      "description": "Discovered a JFrog Identity Token, potentially compromising access to JFrog services and sensitive software artifacts.",
      "regex": "(?:jfrog|artifactory|bintray|xray)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "jfrog",
        "artifactory",
        "bintray",
        "xray"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "jwt",
      "description": "Uncovered a JSON Web Token, which may lead to unauthorized access to web applications and sensitive user data.",
      "regex": "\\b(ey[a-zA-Z0-9]{17,}\\.ey[a-zA-Z0-9\\/\\\\_-]{17,}\\.(?:[a-zA-Z0-9\\/\\\\_-]{10,}={0,2})?)(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "keywords": [
        "ey"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "jwt-base64",
      "description": "Detected a Base64-encoded JSON Web Token, posing a risk of exposing encoded authentication and data exchange information.",
      "regex": "\\bZXlK(?:(?<alg>aGJHY2lPaU)|(?<apu>aGNIVWlPaU)|(?<apv>aGNIWWlPaU)|(?<aud>aGRXUWlPaU)|(?<b64>aU5qUWlP)|(?<crit>amNtbDBJanBi)|(?<cty>amRIa2lPaU)|(?<epk>bGNHc2lPbn)|(?<enc>bGJtTWlPaU)|(?<jku>cWEzVWlPaU)|(?<jwk>cWQyc2lPb)|(?<iss>cGMzTWlPaU)|(?<iv>cGRpSTZJ)|(?<kid>cmFXUWlP)|(?<key_ops>clpYbGZiM0J6SWpwY)|(?<kty>cmRIa2lPaUp)|(?<nonce>dWIyNWpaU0k2)|(?<p2c>d01tTWlP)|(?<p2s>d01uTWlPaU)|(?<ppt>d2NIUWlPaU)|(?<sub>emRXSWlPaU)|(?<svt>emRuUWlP)|(?<tag>MFlXY2lPaU)|(?<typ>MGVYQWlPaUp)|(?<url>MWNtd2l)|(?<use>MWMyVWlPaUp)|(?<ver>MlpYSWlPaU)|(?<version>MlpYSnphVzl1SWpv)|(?<x>NElqb2)|(?<x5c>NE5XTWlP)|(?<x5t>NE5YUWlPaU)|(?<x5ts256>NE5YUWpVekkxTmlJNkl)|(?<x5u>NE5YVWlPaU)|(?<zip>NmFYQWlPaU))[a-zA-Z0-9\\/\\\\_+\\-\\r\\n]{40,}={0,2}",
      "keywords": [
        "zxlk"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "kraken-access-token",
      "description": "Identified a Kraken Access Token, potentially compromising cryptocurrency trading accounts and financial security.",
      "regex": "(?:kraken)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9\\/=_\\+\\-]{80,90})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "kraken"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "kucoin-access-token",
      "description": "Found a Kucoin Access Token, risking unauthorized access to cryptocurrency exchange services and transactions.",
      "regex": "(?:kucoin)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-f0-9]{24})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "kucoin"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "kucoin-secret-key",
      "description": "Discovered a Kucoin Secret Key, which could lead to compromised cryptocurrency operations and financial data breaches.",
      "regex": "(?:kucoin)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "kucoin"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "launchdarkly-access-token",
      "description": "Uncovered a Launchdarkly Access Token, potentially compromising feature flag management and application functionality.",
      "regex": "(?:launchdarkly)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9=_\\-]{40})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "launchdarkly"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "linear-api-key",
      "description": "Detected a Linear API Token, posing a risk to project management tools and sensitive task data.",
      "regex": "lin_api_[a-z0-9]{40}",
      "flags": "i",
      "keywords": [
        "lin_api_"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "linear-client-secret",
      "description": "Identified a Linear Client Secret, which may compromise secure integrations and sensitive project management data.",
      "regex": "(?:linear)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-f0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "linear"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "linkedin-client-id",
      "description": "Found a LinkedIn Client ID, risking unauthorized access to LinkedIn integrations and professional data exposure.",
      "regex": "(?:linkedin|linked-in)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{14})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "linkedin",
        "linked-in"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "linkedin-client-secret",
      "description": "Discovered a LinkedIn Client secret, potentially compromising LinkedIn application integrations and user data.",
      "regex": "(?:linkedin|linked-in)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{16})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "linkedin",
        "linked-in"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "lob-api-key",
      "description": "Uncovered a Lob API Key, which could lead to unauthorized access to mailing and address verification services.",
      "regex": "(?:lob)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}((live|test)_[a-f0-9]{35})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "test_",
        "live_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "lob-pub-api-key",
      "description": "Detected a Lob Publishable API Key, posing a risk of exposing mail and print service integrations.",
      "regex": "(?:lob)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}((test|live)_pub_[a-f0-9]{31})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "test_pub",
        "live_pub",
        "_pub"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "lore-authorization-header",
      "description": "An HTTP Authorization header carrying a Bearer/Basic/Token credential.",
      "regex": "authorization\\s*:\\s*(?:bearer|basic|token)\\s+([a-z0-9._\\-+/=]{8,})",
      "flags": "i",
      "keywords": [
        "authorization"
      ],
      "secretGroup": 1,
      "disposition": "redact",
      "origin": "lore"
    },
    {
      "id": "lore-env-secret-assignment",
      "description": "A KEY=value assignment whose key looks secret-bearing (SECRET/TOKEN/PASSWORD/API_KEY/ACCESS_KEY).",
      "regex": "\\b([a-z0-9_]*(?:secret|token|password|passwd|api[_-]?key|access[_-]?key)[a-z0-9_]*)\\s*[:=]\\s*['\"]?([^\\s'\"#]{6,})",
      "flags": "i",
      "keywords": [
        "secret",
        "token",
        "password",
        "passwd",
        "api",
        "access"
      ],
      "secretGroup": 2,
      "disposition": "redact",
      "origin": "lore"
    },
    {
      "id": "mailchimp-api-key",
      "description": "Identified a Mailchimp API key, potentially compromising email marketing campaigns and subscriber data.",
      "regex": "(?:MailchimpSDK.initialize|mailchimp)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-f0-9]{32}-us\\d\\d)(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "mailchimp"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "mailgun-private-api-token",
      "description": "Found a Mailgun private API token, risking unauthorized email service operations and data breaches.",
      "regex": "(?:mailgun)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(key-[a-f0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "mailgun"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "mailgun-pub-key",
      "description": "Discovered a Mailgun public validation key, which could expose email verification processes and associated data.",
      "regex": "(?:mailgun)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(pubkey-[a-f0-9]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "mailgun"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "mailgun-signing-key",
      "description": "Uncovered a Mailgun webhook signing key, potentially compromising email automation and data integrity.",
      "regex": "(?:mailgun)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-h0-9]{32}-[a-h0-9]{8}-[a-h0-9]{8})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "mailgun"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "mapbox-api-token",
      "description": "Detected a MapBox API token, posing a risk to geospatial services and sensitive location data exposure.",
      "regex": "(?:mapbox)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(pk\\.[a-z0-9]{60}\\.[a-z0-9]{22})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "mapbox"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "mattermost-access-token",
      "description": "Identified a Mattermost Access Token, which may compromise team communication channels and data privacy.",
      "regex": "(?:mattermost)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{26})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "mattermost"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "messagebird-api-token",
      "description": "Found a MessageBird API token, risking unauthorized access to communication platforms and message data.",
      "regex": "(?:messagebird|message-bird|message_bird)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{25})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "messagebird",
        "message-bird",
        "message_bird"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "messagebird-client-id",
      "description": "Discovered a MessageBird client ID, potentially compromising API integrations and sensitive communication data.",
      "regex": "(?:messagebird|message-bird|message_bird)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "messagebird",
        "message-bird",
        "message_bird"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "microsoft-teams-webhook",
      "description": "Uncovered a Microsoft Teams Webhook, which could lead to unauthorized access to team collaboration tools and data leaks.",
      "regex": "https:\\/\\/[a-z0-9]+\\.webhook\\.office\\.com\\/webhookb2\\/[a-z0-9]{8}-([a-z0-9]{4}-){3}[a-z0-9]{12}@[a-z0-9]{8}-([a-z0-9]{4}-){3}[a-z0-9]{12}\\/IncomingWebhook\\/[a-z0-9]{32}\\/[a-z0-9]{8}-([a-z0-9]{4}-){3}[a-z0-9]{12}",
      "keywords": [
        "webhook.office.com",
        "webhookb2",
        "incomingwebhook"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "netlify-access-token",
      "description": "Detected a Netlify Access Token, potentially compromising web hosting services and site management.",
      "regex": "(?:netlify)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9=_\\-]{40,46})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "netlify"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "new-relic-browser-api-token",
      "description": "Identified a New Relic ingest browser API token, risking unauthorized access to application performance data and analytics.",
      "regex": "(?:new-relic|newrelic|new_relic)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(NRJS-[a-f0-9]{19})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "nrjs-"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "new-relic-insert-key",
      "description": "Discovered a New Relic insight insert key, compromising data injection into the platform.",
      "regex": "(?:new-relic|newrelic|new_relic)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(NRII-[a-z0-9-]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "nrii-"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "new-relic-user-api-id",
      "description": "Found a New Relic user API ID, posing a risk to application monitoring services and data integrity.",
      "regex": "(?:new-relic|newrelic|new_relic)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "new-relic",
        "newrelic",
        "new_relic"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "new-relic-user-api-key",
      "description": "Discovered a New Relic user API Key, which could lead to compromised application insights and performance monitoring.",
      "regex": "(?:new-relic|newrelic|new_relic)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(NRAK-[a-z0-9]{27})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "nrak"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "npm-access-token",
      "description": "Uncovered an npm access token, potentially compromising package management and code repository access.",
      "regex": "\\b(npm_[a-z0-9]{36})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "npm_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "nytimes-access-token",
      "description": "Detected a Nytimes Access Token, risking unauthorized access to New York Times APIs and content services.",
      "regex": "(?:nytimes|new-york-times,|newyorktimes)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9=_\\-]{32})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "nytimes",
        "new-york-times",
        "newyorktimes"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "okta-access-token",
      "description": "Identified an Okta Access Token, which may compromise identity management services and user authentication data.",
      "regex": "(?:okta)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9=_\\-]{42})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "okta"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "openai-api-key",
      "description": "Found an OpenAI API Key, posing a risk of unauthorized access to AI services and data manipulation.",
      "regex": "\\b(sk-[a-zA-Z0-9]{20}T3BlbkFJ[a-zA-Z0-9]{20})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "t3blbkfj"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "plaid-api-token",
      "description": "Discovered a Plaid API Token, potentially compromising financial data aggregation and banking services.",
      "regex": "(?:plaid)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(access-(?:sandbox|development|production)-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "plaid"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "plaid-client-id",
      "description": "Uncovered a Plaid Client ID, which could lead to unauthorized financial service integrations and data breaches.",
      "regex": "(?:plaid)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{24})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "plaid"
      ],
      "entropy": 3.5,
      "secretGroup": 1,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "plaid-secret-key",
      "description": "Detected a Plaid Secret key, risking unauthorized access to financial accounts and sensitive transaction data.",
      "regex": "(?:plaid)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{30})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "plaid"
      ],
      "entropy": 3.5,
      "secretGroup": 1,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "planetscale-api-token",
      "description": "Identified a PlanetScale API token, potentially compromising database management and operations.",
      "regex": "\\b(pscale_tkn_[a-z0-9=\\-_\\.]{32,64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "pscale_tkn_"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "planetscale-oauth-token",
      "description": "Found a PlanetScale OAuth token, posing a risk to database access control and sensitive data integrity.",
      "regex": "\\b(pscale_oauth_[a-z0-9=\\-_\\.]{32,64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "pscale_oauth_"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "planetscale-password",
      "description": "Discovered a PlanetScale password, which could lead to unauthorized database operations and data breaches.",
      "regex": "\\b(pscale_pw_[a-z0-9=\\-_\\.]{32,64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "pscale_pw_"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "postman-api-token",
      "description": "Uncovered a Postman API token, potentially compromising API testing and development workflows.",
      "regex": "\\b(PMAK-[a-f0-9]{24}\\-[a-f0-9]{34})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "pmak-"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "prefect-api-token",
      "description": "Detected a Prefect API token, risking unauthorized access to workflow management and automation services.",
      "regex": "\\b(pnu_[a-z0-9]{36})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "pnu_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "private-key",
      "description": "Identified a Private Key, which may compromise cryptographic security and sensitive data encryption.",
      "regex": "-----BEGIN[ A-Z0-9_-]{0,100}PRIVATE KEY( BLOCK)?-----[\\s\\S-]*KEY( BLOCK)?----",
      "flags": "i",
      "keywords": [
        "-----begin"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "pulumi-api-token",
      "description": "Found a Pulumi API token, posing a risk to infrastructure as code services and cloud resource management.",
      "regex": "\\b(pul-[a-f0-9]{40})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "pul-"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "pypi-upload-token",
      "description": "Discovered a PyPI upload token, potentially compromising Python package distribution and repository integrity.",
      "regex": "pypi-AgEIcHlwaS5vcmc[A-Za-z0-9\\-_]{50,1000}",
      "keywords": [
        "pypi-ageichlwas5vcmc"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "rapidapi-access-token",
      "description": "Uncovered a RapidAPI Access Token, which could lead to unauthorized access to various APIs and data services.",
      "regex": "(?:rapidapi)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9_-]{50})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "rapidapi"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "readme-api-token",
      "description": "Detected a Readme API token, risking unauthorized documentation management and content exposure.",
      "regex": "\\b(rdme_[a-z0-9]{70})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "rdme_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "rubygems-api-token",
      "description": "Identified a Rubygem API token, potentially compromising Ruby library distribution and package management.",
      "regex": "\\b(rubygems_[a-f0-9]{48})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "rubygems_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "scalingo-api-token",
      "description": "Found a Scalingo API token, posing a risk to cloud platform services and application deployment security.",
      "regex": "\\b(tk-us-[a-zA-Z0-9-_]{48})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "keywords": [
        "tk-us-"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "sendbird-access-id",
      "description": "Discovered a Sendbird Access ID, which could compromise chat and messaging platform integrations.",
      "regex": "(?:sendbird)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "sendbird"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "sendbird-access-token",
      "description": "Uncovered a Sendbird Access Token, potentially risking unauthorized access to communication services and user data.",
      "regex": "(?:sendbird)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-f0-9]{40})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "sendbird"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "sendgrid-api-token",
      "description": "Detected a SendGrid API token, posing a risk of unauthorized email service operations and data exposure.",
      "regex": "\\b(SG\\.[a-z0-9=_\\-\\.]{66})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "sg."
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "sendinblue-api-token",
      "description": "Identified a Sendinblue API token, which may compromise email marketing services and subscriber data privacy.",
      "regex": "\\b(xkeysib-[a-f0-9]{64}\\-[a-z0-9]{16})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "xkeysib-"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "sentry-access-token",
      "description": "Found a Sentry Access Token, risking unauthorized access to error tracking services and sensitive application data.",
      "regex": "(?:sentry)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-f0-9]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "sentry"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "shippo-api-token",
      "description": "Discovered a Shippo API token, potentially compromising shipping services and customer order data.",
      "regex": "\\b(shippo_(live|test)_[a-f0-9]{40})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "shippo_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "shopify-access-token",
      "description": "Uncovered a Shopify access token, which could lead to unauthorized e-commerce platform access and data breaches.",
      "regex": "shpat_[a-fA-F0-9]{32}",
      "keywords": [
        "shpat_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "shopify-custom-access-token",
      "description": "Detected a Shopify custom access token, potentially compromising custom app integrations and e-commerce data security.",
      "regex": "shpca_[a-fA-F0-9]{32}",
      "keywords": [
        "shpca_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "shopify-private-app-access-token",
      "description": "Identified a Shopify private app access token, risking unauthorized access to private app data and store operations.",
      "regex": "shppa_[a-fA-F0-9]{32}",
      "keywords": [
        "shppa_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "shopify-shared-secret",
      "description": "Found a Shopify shared secret, posing a risk to application authentication and e-commerce platform security.",
      "regex": "shpss_[a-fA-F0-9]{32}",
      "keywords": [
        "shpss_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "sidekiq-secret",
      "description": "Discovered a Sidekiq Secret, which could lead to compromised background job processing and application data breaches.",
      "regex": "(?:BUNDLE_ENTERPRISE__CONTRIBSYS__COM|BUNDLE_GEMS__CONTRIBSYS__COM)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-f0-9]{8}:[a-f0-9]{8})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "bundle_enterprise__contribsys__com",
        "bundle_gems__contribsys__com"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "sidekiq-sensitive-url",
      "description": "Uncovered a Sidekiq Sensitive URL, potentially exposing internal job queues and sensitive operation details.",
      "regex": "\\b(http(?:s??):\\/\\/)([a-f0-9]{8}:[a-f0-9]{8})@(?:gems.contribsys.com|enterprise.contribsys.com)(?:[\\/|\\#|\\?|:]|$)",
      "flags": "i",
      "keywords": [
        "gems.contribsys.com",
        "enterprise.contribsys.com"
      ],
      "secretGroup": 2,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "slack-app-token",
      "description": "Detected a Slack App-level token, risking unauthorized access to Slack applications and workspace data.",
      "regex": "(xapp-\\d-[A-Z0-9]+-\\d+-[a-z0-9]+)",
      "flags": "i",
      "keywords": [
        "xapp"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "slack-bot-token",
      "description": "Identified a Slack Bot token, which may compromise bot integrations and communication channel security.",
      "regex": "(xoxb-[0-9]{10,13}\\-[0-9]{10,13}[a-zA-Z0-9-]*)",
      "keywords": [
        "xoxb"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "slack-config-access-token",
      "description": "Found a Slack Configuration access token, posing a risk to workspace configuration and sensitive data access.",
      "regex": "(xoxe.xox[bp]-\\d-[A-Z0-9]{163,166})",
      "flags": "i",
      "keywords": [
        "xoxe.xoxb-",
        "xoxe.xoxp-"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "slack-config-refresh-token",
      "description": "Discovered a Slack Configuration refresh token, potentially allowing prolonged unauthorized access to configuration settings.",
      "regex": "(xoxe-\\d-[A-Z0-9]{146})",
      "flags": "i",
      "keywords": [
        "xoxe-"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "slack-legacy-bot-token",
      "description": "Uncovered a Slack Legacy bot token, which could lead to compromised legacy bot operations and data exposure.",
      "regex": "(xoxb-[0-9]{8,14}\\-[a-zA-Z0-9]{18,26})",
      "keywords": [
        "xoxb"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "slack-legacy-token",
      "description": "Detected a Slack Legacy token, risking unauthorized access to older Slack integrations and user data.",
      "regex": "(xox[os]-\\d+-\\d+-\\d+-[a-fA-F\\d]+)",
      "keywords": [
        "xoxo",
        "xoxs"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "slack-legacy-workspace-token",
      "description": "Identified a Slack Legacy Workspace token, potentially compromising access to workspace data and legacy features.",
      "regex": "(xox[ar]-(?:\\d-)?[0-9a-zA-Z]{8,48})",
      "keywords": [
        "xoxa",
        "xoxr"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "slack-user-token",
      "description": "Found a Slack User token, posing a risk of unauthorized user impersonation and data access within Slack workspaces.",
      "regex": "(xox[pe](?:-[0-9]{10,13}){3}-[a-zA-Z0-9-]{28,34})",
      "keywords": [
        "xoxp-",
        "xoxe-"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "slack-webhook-url",
      "description": "Discovered a Slack Webhook, which could lead to unauthorized message posting and data leakage in Slack channels.",
      "regex": "(https?:\\/\\/)?hooks.slack.com\\/(services|workflows)\\/[A-Za-z0-9+\\/]{43,46}",
      "keywords": [
        "hooks.slack.com"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "snyk-api-token",
      "description": "Uncovered a Snyk API token, potentially compromising software vulnerability scanning and code security.",
      "regex": "(?:snyk_token|snyk_key|snyk_api_token|snyk_api_key|snyk_oauth_token)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "snyk_token",
        "snyk_key",
        "snyk_api_token",
        "snyk_api_key",
        "snyk_oauth_token"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "square-access-token",
      "description": "Detected a Square Access Token, risking unauthorized payment processing and financial transaction exposure.",
      "regex": "\\b((EAAA|sq0atp-)[0-9A-Za-z\\-_]{22,60})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "sq0atp-",
        "eaaa"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "squarespace-access-token",
      "description": "Identified a Squarespace Access Token, which may compromise website management and content control on Squarespace.",
      "regex": "(?:squarespace)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "squarespace"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "stripe-access-token",
      "description": "Found a Stripe Access Token, posing a risk to payment processing services and sensitive financial data.",
      "regex": "\\b((sk|rk)_(test|live|prod)_[0-9a-z]{10,99})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "sk_test",
        "sk_live",
        "sk_prod",
        "rk_test",
        "rk_live",
        "rk_prod"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "sumologic-access-id",
      "description": "Discovered a SumoLogic Access ID, potentially compromising log management services and data analytics integrity.",
      "regex": "(?:(?:sumo)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3})(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(su[a-zA-Z0-9]{12})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "sumo"
      ],
      "entropy": 3,
      "secretGroup": 1,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "sumologic-access-token",
      "description": "Uncovered a SumoLogic Access Token, which could lead to unauthorized access to log data and analytics insights.",
      "regex": "(?:sumo)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{64})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "sumo"
      ],
      "entropy": 3,
      "secretGroup": 1,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "telegram-bot-api-token",
      "description": "Detected a Telegram Bot API Token, risking unauthorized bot operations and message interception on Telegram.",
      "regex": "(?:(?:telegr)(?:[0-9a-z\\(-_\\t .\\\\]{0,40})(?:[\\s|']|[\\s|\"]){0,3})(?:=|\\|\\|:|<=|=>|:|\\?=|\\()(?:'|\\\"|\\s|=|\\x60){0,5}([0-9]{5,16}:A[a-z0-9_\\-]{34})(?:['|\\\"|\\n|\\r|\\s|\\x60|;|\\\\]|$)",
      "flags": "i",
      "keywords": [
        "telegr"
      ],
      "secretGroup": 0,
      "disposition": "quarantine",
      "origin": "gitleaks"
    },
    {
      "id": "travisci-access-token",
      "description": "Identified a Travis CI Access Token, potentially compromising continuous integration services and codebase security.",
      "regex": "(?:travis)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{22})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "travis"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "twilio-api-key",
      "description": "Found a Twilio API Key, posing a risk to communication services and sensitive customer interaction data.",
      "regex": "SK[0-9a-fA-F]{32}",
      "keywords": [
        "twilio"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "twitch-api-token",
      "description": "Discovered a Twitch API token, which could compromise streaming services and account integrations.",
      "regex": "(?:twitch)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{30})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "twitch"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "twitter-access-secret",
      "description": "Uncovered a Twitter Access Secret, potentially risking unauthorized Twitter integrations and data breaches.",
      "regex": "(?:twitter)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{45})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "twitter"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "twitter-access-token",
      "description": "Detected a Twitter Access Token, posing a risk of unauthorized account operations and social media data exposure.",
      "regex": "(?:twitter)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([0-9]{15,25}-[a-zA-Z0-9]{20,40})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "twitter"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "twitter-api-key",
      "description": "Identified a Twitter API Key, which may compromise Twitter application integrations and user data security.",
      "regex": "(?:twitter)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{25})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "twitter"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "twitter-api-secret",
      "description": "Found a Twitter API Secret, risking the security of Twitter app integrations and sensitive data access.",
      "regex": "(?:twitter)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{50})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "twitter"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "twitter-bearer-token",
      "description": "Discovered a Twitter Bearer Token, potentially compromising API access and data retrieval from Twitter.",
      "regex": "(?:twitter)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(A{22}[a-zA-Z0-9%]{80,100})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "twitter"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "typeform-api-token",
      "description": "Uncovered a Typeform API token, which could lead to unauthorized survey management and data collection.",
      "regex": "(?:typeform)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(tfp_[a-z0-9\\-_\\.=]{59})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "tfp_"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "vault-batch-token",
      "description": "Detected a Vault Batch Token, risking unauthorized access to secret management services and sensitive data.",
      "regex": "\\b(hvb\\.[a-z0-9_-]{138,212})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "hvb"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "vault-service-token",
      "description": "Identified a Vault Service Token, potentially compromising infrastructure security and access to sensitive credentials.",
      "regex": "\\b(hvs\\.[a-z0-9_-]{90,100})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "hvs"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "yandex-access-token",
      "description": "Found a Yandex Access Token, posing a risk to Yandex service integrations and user data privacy.",
      "regex": "(?:yandex)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(t1\\.[A-Z0-9a-z_-]+[=]{0,2}\\.[A-Z0-9a-z_-]{86}[=]{0,2})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "yandex"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "yandex-api-key",
      "description": "Discovered a Yandex API Key, which could lead to unauthorized access to Yandex services and data manipulation.",
      "regex": "(?:yandex)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(AQVN[A-Za-z0-9_\\-]{35,38})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "yandex"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "yandex-aws-access-token",
      "description": "Uncovered a Yandex AWS Access Token, potentially compromising cloud resource access and data security on Yandex Cloud.",
      "regex": "(?:yandex)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}(YC[a-zA-Z0-9_\\-]{38})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "yandex"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    },
    {
      "id": "zendesk-secret-key",
      "description": "Detected a Zendesk Secret Key, risking unauthorized access to customer support services and sensitive ticketing data.",
      "regex": "(?:zendesk)(?:[0-9a-z\\-_\\t .]{0,20})(?:[\\s|']|[\\s|\"]){0,3}(?:=|>|:{1,3}=|\\|\\|:|<=|=>|:|\\?=)(?:'|\\\"|\\s|=|\\x60){0,5}([a-z0-9]{40})(?:['|\\\"|\\n|\\r|\\s|\\x60|;]|$)",
      "flags": "i",
      "keywords": [
        "zendesk"
      ],
      "secretGroup": 0,
      "disposition": "redact",
      "origin": "gitleaks"
    }
  ]
}
